



































import { Component, Prop } from "vue-property-decorator";
import { InputFieldCpt } from "@/core/components/common";

import AppVue from "@/AppVue.vue";
import { ApplicationModel } from "@/core/webapi";

@Component({
  components: {
    InputFieldCpt,
  },
})
export default class Step2Cpt extends AppVue {
  @Prop() model: ApplicationModel;
}
